<template>
  <section>
    <one-line-form :submit="updateFirstName" :submittable="isValid" :saving="isSaving ? firstName : ''">
      <input-field name="firstname"
                   :class="{ invisible: isSaving }"
                   type="text"
                   :title="i18n.t('firstName:first_name')"
                   :placeholder="i18n.t('firstName:enter_first_name')"
                   :autocapitalize="true"
                   :autocorrect="false"
                   :autocomplete="'given-name'"
                   :value="firstName"
                   :suggestion="matchFirstName"
                   v-mask="partner.fullNameRegExp ? partner.fullNameRegExp : null"
                   @maskInput="syncFirstName" />
    </one-line-form>
    <helper v-if="isJapaneseIsleOfMan" :class="{ invisible: isSaving }"> {{ i18n.t('lastName:last_name_hint') }} </helper>
    <numb-area></numb-area>
    <show-keyboard></show-keyboard>
  </section>
</template>

<style>
</style>

<script>
  import Vue from 'vue'
  import { mapState, mapGetters } from 'vuex'
  import { getNestedProperty } from '../utils/structure.js'
  import fieldCustomRules from '../mixins/customFieldsRules'

  export default Vue.component('personal-firstname-screen', {
    props: ['screenParams'],
    mixins: [
      fieldCustomRules
    ],
    data () {
      const prediction = this.$store.state.prediction.person
      const autofill = this.$store.state.autofill
      const facebookData = this.$store.state.socialMediaData.facebook && this.$store.state.socialMediaData.facebook.profile
      const googleData = this.$store.state.socialMediaData.google && this.$store.state.socialMediaData.google.profile
      const linkedInData = this.$store.state.socialMediaData.linkedIn && this.$store.state.socialMediaData.linkedIn.profile
      const socialMediaData = facebookData || googleData || linkedInData

      const key = this.screenParams && this.screenParams.dispatchKey ? this.screenParams.dispatchKey.replace('update', '').toLowerCase() : 'user'
      const propertyName = (this.screenParams && this.screenParams.propertyName) || 'firstName'
      const currentValue = getNestedProperty(this.$store.state[key], propertyName)

      return {
        firstName: currentValue || (prediction && prediction.firstName) || (autofill.enabled && autofill.firstName) || (socialMediaData && socialMediaData.firstName) || '',
        isSaving: false,
        matchPerson: {},
        matchFirstName: '',
        propertyName: propertyName,
        dispatchKey: (this.screenParams && this.screenParams.dispatchKey) || 'updateUser'
      }
    },
    computed: {
      ...mapState(['user', 'partner']),
      ...mapGetters(['isJapaneseIsleOfMan']),
      isValid () {
        return this.isValidLength(this.firstName,'firstName')
      },
    },
    methods: {
      syncFirstName (value) {
        if (!this.usingPrefill && value !== this.firstName) this.usingPrefill = false

        if (value.length > 0) {
          this.matchPerson = this.$store.state.phonePrediction.persons.find((p) => p.firstName.substring(0, value.length).toLowerCase() === value.toLowerCase())
          if (this.matchPerson) {
            this.matchFirstName = this.matchPerson.firstName
            this.firstName = this.formatName(value)
          } else {
            this.matchFirstName = ''
          }
        } else {
          this.matchFirstName = ''
        }

        this.firstName = this.formatName(value)
      },
      updateFirstName () {
        if (this.firstName) {
          if (this.matchFirstName) {
            this.firstName = this.matchFirstName
            this.usingPrefill = true
            this.$store.commit('updatePhonePrediction', {
              matchPerson: this.matchPerson
            })
          } else {
            this.$store.commit('updatePhonePrediction', {
              matchPerson: {}
            })
          }
          this.isSaving = true

          let dispatchData = {}
          dispatchData[this.propertyName] = this.firstName
          this.$store.dispatch(this.dispatchKey, dispatchData)

          this.trackPrefill('firstName', this.firstName)
          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        }
      },
      formatName (string) {
        const trimmed = string.replace(/\s\s+/g, ' ').trim()

        if (this.isJapaneseRomaji(string)) return trimmed
        const parts = trimmed.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1))
        return parts.join(' ')
      },
      isJapaneseRomaji (string) {
        return /[ａ-ｚＡ-Ｚ]/g.test(string)
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/screens/PersonalFirstName.vue